module.exports = __webpack_public_path__ + "media/assets/img/products/studio_proofreading-unavailable-ef86ad1cd9b1c364dd51c32d20093481.svg";